import React from 'react';
import { Payment, Link as LinkIcon } from '@mui/icons-material';

const PaymentChoiceModal = ({ show, onClose, customer, onChooseDemande, onChooseLien }) => {
    if (!show) return null;
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm">
            <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm overflow-hidden border border-slate-200">
                <div className="px-5 py-4 border-b border-slate-100">
                    <h3 className="text-lg font-bold text-slate-800">Paiement</h3>
                    <p className="text-sm text-slate-500 mt-0.5">Choisissez le type d&apos;envoi pour ce client</p>
                </div>
                <div className="p-3 space-y-2">
                    <button
                        type="button"
                        onClick={() => { onChooseDemande(customer); onClose(); }}
                        className="w-full flex items-center gap-3 px-4 py-3 rounded-xl border-2 border-slate-200 hover:border-amber-300 hover:bg-amber-50 transition-all text-left"
                    >
                        <div className="w-10 h-10 rounded-xl bg-emerald-100 flex items-center justify-center">
                            <Payment className="text-emerald-600 w-5 h-5" />
                        </div>
                        <div>
                            <span className="font-semibold text-slate-800 block">Demande de paiement</span>
                            <span className="text-xs text-slate-500">Envoyer une demande à valider par le client</span>
                        </div>
                    </button>
                    <button
                        type="button"
                        onClick={() => { onChooseLien(customer); onClose(); }}
                        className="w-full flex items-center gap-3 px-4 py-3 rounded-xl border-2 border-slate-200 hover:border-amber-300 hover:bg-amber-50 transition-all text-left"
                    >
                        <div className="w-10 h-10 rounded-xl bg-blue-100 flex items-center justify-center">
                            <LinkIcon className="text-blue-600 w-5 h-5" />
                        </div>
                        <div>
                            <span className="font-semibold text-slate-800 block">Lien de paiement</span>
                            <span className="text-xs text-slate-500">Générer un lien à envoyer (SMS, email…)</span>
                        </div>
                    </button>
                </div>
                <div className="p-3 border-t border-slate-100">
                    <button type="button" onClick={onClose} className="w-full py-2.5 rounded-xl border border-slate-200 text-slate-600 hover:bg-slate-50 font-medium text-sm">
                        Annuler
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PaymentChoiceModal;
